module.exports = {
  version: '3.4.11',
  raven: 'https://eaf6fe8a68c64ad9b8ec28d8294e550f@sentry.io/1233030'
}
